import Icon from '@tiger/icons';

export default Icon;
